// ***********************************  SUPER FORM STARTS HERE **********************************************

(function( jQuery ){
  /* ------------------------------------------------------------------ helpers */
  const $$ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$$ = (sel, ctx = document) => ctx.querySelectorAll(sel);

  const forms = $$$('.super-product-form');
  if (!forms.length) return;

  /* ------------------------------------------------------ delegation for clicks */
  document.body.addEventListener('click', e => {
    const btn  = e.target.closest('button');
    if (!btn) return;
    const form = btn.closest('.super-product-form');
    if (!form) return;

    if (btn.parentElement.classList.contains('buying-option')) {
      activate(btn);
      updateBuyingArea(form);
      updateJarTexts(form); // ✅ Add this line to refresh all jar prices
    } else if (btn.parentElement.classList.contains('jars-option')) {
      activate(btn);         updateBuyingArea(form); updateJarTexts(form);
    } else if (btn.parentElement.classList.contains('frequency-option')) {
      activate(btn);
    } else if (btn.classList.contains('add-to-cart')) {
      addToCart(form);
    }
  });

  /* ----------------------------------------------------------- first paint */
  forms.forEach(f => { updateBuyingArea(f); updateJarTexts(f); f.classList.remove('loading'); });

  /* ========================================================== functions */

  function activate(btn) {
    btn.parentElement.querySelectorAll('.active').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
  }

  function updateJarTexts(form) {
    const isSub = $$('.buying-option .active', form).dataset.option === 'subscribe';
    const jarButtons = $$$('.jars-option button', form);

    jarButtons.forEach(btn => {
      const txt = isSub ? btn.dataset.displayPerjarSub : btn.dataset.displayPerjarOnetime;
      const priceEl = btn.querySelector('.price-value');
      if (priceEl) priceEl.innerHTML = `${txt} each`;
    });
  }


  function updateBuyingArea(form) {
    const jar = $$('.jars-option .active', form);
    const oneBtn = $$('[data-option="one-time"]', form);
    const subBtn = $$('[data-option="subscribe"]', form);

    const one = oneBtn?.querySelector('.price-value');
    const sub = subBtn?.querySelector('.price-value');

    const onePrice = parseInt(jar.dataset.priceOnetime || "0");
    const subPrice = parseInt(jar.dataset.priceSubscribe || "0");
    const compareAt = parseInt(jar.dataset.compareAtPrice || "0");

    const displayOne = jar.dataset.displayOnetime;
    const displaySub = jar.dataset.displaySubscribe;
    const displayCompareOne = jar.dataset.displayCompareOnetime;
    const displayCompareSub = jar.dataset.displayCompareSubscribe;

    if (one) {
      one.innerHTML = (compareAt > onePrice && displayCompareOne)
        ? `<s>${displayCompareOne}</s> ${displayOne}`
        : `${displayOne}`;
    }

    if (sub && subBtn) {
      sub.innerHTML = (compareAt > subPrice && displayCompareSub)
        ? `<s>${displayCompareSub}</s> ${displaySub}`
        : `${displaySub}`;

      // insert savings label
      const titleEl = subBtn.querySelector('.price-title');
      const oldSave = subBtn.querySelector('.subscription-savings');
      if (oldSave) oldSave.remove(); // remove any existing one

      const savingsText = jar.dataset.subscribeSavings;
      if (savingsText && titleEl) {
        const div = document.createElement('div');
        div.className = 'subscription-savings';
        div.innerHTML = `Save ${savingsText}`;
        div.style.fontSize = '12px';
        div.style.fontWeight = '600';
        div.style.color = '#008000';
        div.style.marginBottom = '4px';
        titleEl.parentNode.insertBefore(div, titleEl);
      }
    }



    // show / hide frequency box
    const subBox = $$('.frequency-option', form);
    const head   = $$('.delivery-heading', form);
    const subMode = $$('.buying-option .active', form).dataset.option === 'subscribe';

    if (subBox) subBox.style.display = subMode ? 'flex' : 'none';
    if (head)   head.style.display   = subMode ? 'block' : 'none';
    if (!subMode) {
      $$$('.jars-option button .frequency-label', form).forEach(span => span.remove());
    }


    // ✅ Auto-select delivery option based on jar count
    if (subMode && subBox) {
      const jarButtons  = Array.from($$$('.jars-option button', form));
      const activeJar   = jarButtons.find(b => b.classList.contains('active'));
      const freqButtons = $$$('.frequency-option button', form);
    
      // clear existing
      freqButtons.forEach(b => b.classList.remove('active'));
    
      // map n-th jar button ↔ n-th freq button
      const jarIndex = Math.min(jarButtons.indexOf(activeJar), freqButtons.length - 1);
      freqButtons[jarIndex].classList.add('active');
    
      // now inject your labels
      updateVariantLabelsWithFrequency(form);
    }

    // Handle Installment Block visibility + update
    const shippingInstallment = $$('.su-installment', form);
    const installmentValue = $$('.installment-value', form);
    const rawOnetimeHTML = jar?.dataset.displayOnetime;

    if (shippingInstallment && installmentValue) {
      if (subMode) {
        shippingInstallment.style.display = 'none';
      } else {
        shippingInstallment.style.display = 'block';

        if (rawOnetimeHTML) {
          updateInstallmentDisplay(rawOnetimeHTML, installmentValue);
        }
      }
    }

  }

  function addToCart(form) {
      const variantId   = $$('.jars-option .active', form).dataset.variantId;
      const subMode     = $$('.buying-option .active', form).dataset.option === 'subscribe';
      const planBtn     = $$('.frequency-option .active', form);
      const sellingPlan = subMode && planBtn ? planBtn.dataset.sellingPlanId : null;
      const quantity    = 1;

      const btn = $$('.add-to-cart', form);
      btn.disabled = true;
      btn.textContent = 'Adding…';

      const formData = new URLSearchParams({ id: variantId, quantity: quantity });
      if (sellingPlan) formData.append('selling_plan', sellingPlan);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
        .then(response => response.json())
        .then(data => {
          if (data.status === 422) {
            console.error(data.message);
          } else {
            document.dispatchEvent(new CustomEvent('product:added', {
              bubbles: true,
              detail: {
                variant: data,
                quantity: quantity
              }
            }));
          }
        })
        .catch(error => {
          console.error("There was an error adding the product to the cart:", error);
        })
        .finally(() => {
          btn.disabled = false;
          btn.textContent = 'Add to Cart';
        });
    }

    function updateVariantLabelsWithFrequency(form) {
      const subMode = $$('.buying-option .active', form).dataset.option === 'subscribe';
      const freqButtons = $$$('.frequency-option button', form);
      const jarButtons = $$$('.jars-option button', form);

      if (!subMode || !freqButtons.length || !jarButtons.length) return;

      jarButtons.forEach((btn, idx) => {
        const jars = parseInt(btn.dataset.jars || "1");

        // Map jar count to frequency index (1 jar → 0, 2 jars → 1, 4+ jars → 2)
        const freqIndex = Math.min(idx, freqButtons.length - 1);
        const freqTextRaw = freqButtons[freqIndex]?.textContent?.trim();

        if (!freqTextRaw) return;

        const labelText = `Delivered Every ${freqTextRaw}`;

        // Remove old span if exists
        const existingSpan = btn.querySelector('.frequency-label');
        if (existingSpan) existingSpan.remove();

        const titleEl = btn.querySelector('.price-title');
        if (titleEl && titleEl.parentNode) {
          const span = document.createElement('span');
          span.className = 'frequency-label';
          span.style.fontSize = '12px';
          span.style.color = '#666';
          span.style.display = 'block';
          span.textContent = labelText;

          // Insert after .price-title
          titleEl.parentNode.insertBefore(span, titleEl.nextSibling);
        }
      });
    }

  function decodeHTML(html) {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  }

  function extractAmountAndCurrency(htmlString) {
    const decoded = decodeHTML(htmlString); // e.g., <span class=money>$159.99 AUD</span>
    const match = decoded.match(/([\D]*)(\d[\d.,]*)\s*([A-Z]{3})?/i);
    if (!match) return { amount: 0, symbol: "", currency: "" };

    return {
      symbol: (match[1] || "").trim(),         // this gives "$"
      amount: parseFloat(match[2].replace(/,/g, '')),
      currency: match[3] || ""
    };
  }


  function updateInstallmentDisplay(displayAttr, valueEl) {
    const { symbol, amount, currency } = extractAmountAndCurrency(displayAttr);

    if (!amount || !valueEl) return;

    const quarter = (amount / 4).toFixed(2);
    valueEl.innerHTML = `${symbol}${quarter} ${currency}`.trim();
  }



  /* ----------------------------- tiny debug helpers -------------------- */
  window.debugTile = sel => updateBuyingArea($$(sel));
  console.log('%c✓ slim JS loaded — no maths, no currency logic', 'color:#0a0');

  })( window.GemQuery || jQuery );

  document.addEventListener('DOMContentLoaded', () => {
    const configs = [
      { handle: 'sale-the-ultimate-weight-loss-protocol-3', variantId: '41864876884045' },
      { handle: 'new-improved-protocol',            variantId: '41427929792589' },
      // …add as many as you like
    ];
  
    configs.forEach(({ handle, variantId }) => {
      const gridBlock = document.querySelector(`.bf-grid-block[data-filter-handle="${handle}"]`);
      if (!gridBlock) return; // nothing to do on this page
  
      const proButton = gridBlock.querySelector(`button[data-variant-id="${variantId}"]`);
      const bullets   = gridBlock.querySelector('.wlp-bullets');
  
      function updateBulletsVisibility() {
        bullets.style.display = proButton.classList.contains('active') ? 'block' : 'none';
      }
  
      // initial state
      updateBulletsVisibility();
  
      // re-run on any option click
      const buttons = gridBlock.querySelectorAll('.jars-option button');
      buttons.forEach(btn => {
        btn.addEventListener('click', () => {
          buttons.forEach(b => b.classList.remove('active'));
          btn.classList.add('active');
          updateBulletsVisibility();
        });
      });
    });
  });



// ***********************************  SUPER FORM ENDS HERE **********************************************


// ***********************************  PRODUCT LEFT BADGE STARTS HERE **********************************************

document.addEventListener("DOMContentLoaded", function () {

  const scriptVersion = "v7";
  
  const today = new Date();
  const inventoryByDate = {
    // Pre-BF
    "2025-11-24": { upper: 1700, lower: 1200 },
    "2025-11-25": { upper: 1700, lower: 1200 },
    "2025-11-26": { upper: 1200, lower: 900 },

    // BF days will be overridden below but we keep something here as default
    "2025-11-27": { upper: 1700, lower: 1200 },
    "2025-11-28": { upper: 1200,  lower: 900 },
    "2025-11-29": { upper: 900,  lower: 700 },
    "2025-11-30": { upper: 700,  lower: 400 },
    "2025-12-01": { upper: 700,  lower: 400 },

    // Post-BF tail
    "2025-12-02": { upper: 400, lower: 250 },
    "2025-12-03": { upper: 400, lower: 250 },
    "2025-12-04": { upper: 250, lower: 150 },
    "2025-12-05": { upper: 250, lower: 150 },
    "2025-12-06": { upper: 150, lower: 80 },
    "2025-12-07": { upper: 150, lower: 50 },
  };
  
  // Format today’s date as yyyy-mm-dd
  const todayKey = today.toISOString().split("T")[0];
  
  // Use today’s range or fallback to the first one
  const range = inventoryByDate[todayKey] || { upper: 1700, lower: 1200 };

  
  const productBlocks = document.querySelectorAll(".bf-grid-block");

  productBlocks.forEach((block) => {
    const handle = block.getAttribute("data-filter-handle");
    const counterEl = block.querySelector(".randomnumber span");

    if (!handle || !counterEl) return;

    const baseKey = btoa(handle).slice(0, 8);
    const countKey = `invdata-${baseKey}`;
    const timeKey = `invts-${baseKey}`;
    const now = Date.now();

    let saved = JSON.parse(localStorage.getItem(countKey));
    let visitStart = parseInt(localStorage.getItem(timeKey)) || now;
    
    // Reset if version changed or not found
    if (!saved || saved.version !== scriptVersion) {
      const startNum = getRandom(range.upper - 10, range.upper + 20);
      saved = {
        current: startNum,
        lower: range.lower,
        initial: startNum,
        version: scriptVersion
      };
      localStorage.setItem(countKey, JSON.stringify(saved));
      localStorage.setItem(timeKey, now);
    }

    counterEl.textContent = saved.current;

    let visibilityPaused = false;

    function updateCounter() {
      if (document.hidden) {
        visibilityPaused = true;
        return;
      }

      let data = JSON.parse(localStorage.getItem(countKey));
      let timeSpent = (Date.now() - visitStart) / 1000;
      let dropRate;

      // Smart decay based on time spent
      if (timeSpent < 300) dropRate = getRandom(1, 2);
      else if (timeSpent < 900) dropRate = getRandom(1, 2);
      else if (timeSpent < 1800) dropRate = 1;
      else dropRate = Math.random() < 0.4 ? 1 : 0;

      // Per-visit max drop limit
      const maxDrop = 50;
      const droppedSoFar = saved.initial - data.current;
      if (droppedSoFar >= maxDrop) return;

      if (data.current > data.lower) {
        data.current = Math.max(data.lower, data.current - dropRate);
        counterEl.textContent = data.current;
        localStorage.setItem(countKey, JSON.stringify(data));
      }

      setTimeout(updateCounter, getRandom(10000, 20000));
    }

    // Resume when tab becomes active again
    document.addEventListener("visibilitychange", () => {
      if (!document.hidden && visibilityPaused) {
        visibilityPaused = false;
        updateCounter();
      }
    });

    // Start countdown
    setTimeout(updateCounter, getRandom(3000, 6000));
  });

  function getRandom(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
});


// ***********************************  PRODUCT LEFT BADGE ENDS HERE **********************************************